import { useAppDispatch, useAppSelector } from 'hooks';
import { useCallback } from 'react';
import {
  selectCsatStates,
  selectNextStepId,
  setCsatStatesByKey,
} from 'reducers/workflows/index';
import { FAKE_AUTOFLOWS_STEP_ID } from '../consts';
import { useUpdateConversation } from '../hooks';
import { endLiveChat } from 'actions/live-chat';

export const useContinueExecutionAfterCsat = () => {
  const dispatch = useAppDispatch();
  const updateConversation = useUpdateConversation();
  const nextStepId = useAppSelector(selectNextStepId);
  const csatStates = useAppSelector(selectCsatStates);

  const { actionToExecuteAfterCsatDismiss } = csatStates;

  const continueExecution = useCallback(() => {
    if (actionToExecuteAfterCsatDismiss === 'end-live-chat') {
      dispatch(
        endLiveChat({
          shouldResolveConversation: false,
        }),
      );
    } else if (
      actionToExecuteAfterCsatDismiss === 'resume-from-trigger-point'
    ) {
      // only use update conversation to continue executing the workflow if we're in classic workflow
      if (nextStepId !== FAKE_AUTOFLOWS_STEP_ID) {
        updateConversation({ csat_trigger_point_prompted: true });
      }
    }

    dispatch(
      setCsatStatesByKey({
        actionToExecuteAfterCsatDismiss: null,
      }),
    );
  }, [
    actionToExecuteAfterCsatDismiss,
    nextStepId,
    updateConversation,
    dispatch,
  ]);

  return continueExecution;
};
